module.exports = __webpack_public_path__ + "img/papel-higienico.3156e6e1.png";